export default __webpack_public_path__ + "static/media/2 Manager Desk.f72c7e11.jpg";